export default __webpack_public_path__ + "static/media/project_3_pic.b80a7ba4.png";